import PropTypes from 'prop-types';

import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';
import {
  IsLoadingDefaultProps,
  IsLoadingPropTypes,
} from '@/common/proptypes/Base/IsLoading.proptypes';

export const ProductDefaultProps = {
  ...DisabledDefaultProps,
  ...IsLoadingDefaultProps,
  agrementFgaz: false,
  brand: {},
  bundleParents: [],
  categories: [],
  codeOldCompanySku: null,
  companyAvailability: false,
  complementaryDescription: null,
  configurations: [],
  context: null,
  customerPrice: null,
  details: {},
  discountClasses: [],
  discountPrice: null,
  energetics: {},
  exclusivity: null,
  flags: [],
  hasPrice: true,
  hasStock: true,
  id: null,
  invoiceUnit: null,
  isBundle: false,
  isFavorite: false,
  isSalable: false,
  links: {},
  mainSku: null,
  manufacturerSku: null,
  mustSubstitute: null,
  name: null,
  onAddPredictions: () => {},
  path: null,
  productDiff: [],
  publicPrice: null,
  range: null,
  related: [],
  saleUnit: null,
  salesPackaging: null,
  sku: null,
  slider: null,
  slug: null,
  sortables: {},
  splitPackaging: false,
  stockStatus: null,
  stocks: [],
  substitute: null,
  video: {},
  weeeAmount: null,
};

export const ProductPropTypes = {
  ...DisabledPropTypes,
  ...IsLoadingPropTypes,
  agrementFgaz: PropTypes.string,
  brand: PropTypes.shape({
    logo: PropTypes.shape({}),
    name: PropTypes.string,
  }),
  bundleParents: PropTypes.arrayOf(PropTypes.shape({})),
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      depth: PropTypes.number,
      id: PropTypes.number,
      label: PropTypes.string,
    }),
  ),
  codeOldCompanySku: PropTypes.string,
  companyAvailability: PropTypes.bool,
  complementaryDescription: PropTypes.string,
  configurations: PropTypes.arrayOf(PropTypes.shape({})),
  context: PropTypes.string,
  customerPrice: PropTypes.number,
  details: PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.shape({})),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  discountClasses: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  ),
  discountPrice: PropTypes.number,
  energetics: PropTypes.shape({
    energy_classes: PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.shape({})),
      meta: PropTypes.shape({}),
    }),
    links: PropTypes.arrayOf(PropTypes.string),
  }),
  exclusivity: PropTypes.string,
  flags: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      label: PropTypes.string,
      slug: PropTypes.string,
    }),
  ),
  hasPrice: PropTypes.bool,
  hasStock: PropTypes.bool,
  id: PropTypes.string,
  invoiceUnit: PropTypes.string,
  isBundle: PropTypes.bool,
  isFavorite: PropTypes.bool,
  isSalable: PropTypes.bool,
  links: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  mainSku: PropTypes.string,
  manufacturerSku: PropTypes.string,
  mustSubstitute: PropTypes.bool,
  name: PropTypes.string,
  onAddPredictions: PropTypes.func,
  path: PropTypes.string,
  productDiff: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string,
      slug: PropTypes.string,
    }),
  ),
  publicPrice: PropTypes.number,
  range: PropTypes.string,
  related: PropTypes.arrayOf(PropTypes.shape({})),
  saleUnit: PropTypes.string,
  salesPackaging: PropTypes.number,
  sku: PropTypes.string,
  slider: PropTypes.arrayOf(PropTypes.shape({})),
  slug: PropTypes.string,
  sortables: PropTypes.oneOfType([
    PropTypes.shape({
      [PropTypes.string]: PropTypes.shape({
        code: PropTypes.string,
        displayable: PropTypes.bool,
        filterable: PropTypes.bool,
        label: PropTypes.string,
        order: PropTypes.number,
        searchable: PropTypes.bool,
        sortable: PropTypes.bool,
        unit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
    }),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  splitPackaging: PropTypes.bool,
  stockStatus: PropTypes.string,
  stocks: PropTypes.arrayOf(PropTypes.shape({})),
  substitute: PropTypes.oneOfType([
    PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string,
      slug: PropTypes.string,
    }),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  video: PropTypes.shape({}),
  weeeAmount: PropTypes.number,
};
